import { FailedToGetData, H2, Hr, Loading } from 'src/components/_commons';
import { Groups } from './subcomponents/Groups';
import { helpers, userServices } from 'src/services';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { typePreachingGroup, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';

export const AdminsGroups = () => {
    const [groups, setGroups] = useState<typePreachingGroup[] | null>(null);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [numberConfirmed, setNumberConfirmed] = useState(false);
    const [numberOfGroups, setNumberOfGroups] = useState<number | null>(null);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const isValid: boolean = useMemo(() =>
        numberConfirmed
        && !!groups
        && !!numberOfGroups
        && numberOfGroups >= groups.length
        && groups.every(g => g.users.some(u => u.groupIsTheOverseer))
        && groups.every(g => g.users.some(u => u.groupIsTheOverseer))
        && !groups.some(g => g.numberOfGroup > numberOfGroups)
    , [groups, numberConfirmed, numberOfGroups]);

    const saveHandler = () => {
        if (!isValid) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            title: 'Confirmar',
            message: 'Se van a guardar los cambios en los Grupos de Predicación',
            animation: 3,
            mode: 'confirm',
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.SetPreachingGroups(groups!);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                // setRefreshCounter(x => x + 1);
                window.location.reload();  // refreshing current user
            }
        }));
    }

    const cancelHandler = () => {
        dispatch(setValuesAndOpenAlertModalReducer({
            title: '¿Cancelar?',
            message: 'Se van a perder todos los cambios',
            animation: 3,
            mode: 'confirm',
            execution: () => {
                setRefreshCounter(x => x + 1);
            }
        }));
    }

    useEffect(() => {
        helpers.GoToTop();
        setNumberConfirmed(false);
        setIsLoading1(true);
        userServices.GetPreachingGroups().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.preachingGroups) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setGroups(response.data.preachingGroups);
            setNumberOfGroups(response.data.preachingGroups.length);
        });
    }, [refreshCounter]);

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        });
    }, []);

    if (isLoading1 || isLoading2) {
        return <Loading mt={'80px'} />;
    }

    if (!groups || !users) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'GRUPOS DE PREDICACIÓN'} />
        <div className={'text-center'}>
            <label className={isDarkMode ? 'text-white' : ''}>
                Hay {groups.length} grupos
            </label>
            <div className={'d-flex justify-content-center'}>
                <input type={'number'}
                    className={'form-control mt-2'}
                    style={{ maxWidth: '100px' }}
                    placeholder={'0'}
                    value={numberOfGroups || ''}
                    onChange={e => {
                        const c = parseInt(e.target.value) || 0;
                        if (c < 0 || c > 20) {
                            return;
                        }
                        setNumberOfGroups(c);
                    }}
                    disabled={numberConfirmed}
                />
            </div>
            <button className={'btn btn-general-blue mt-3'}
                onClick={() => {
                    if (numberOfGroups! > groups.length) {
                        let newGroups: typePreachingGroup[] = [];
                        for (let i = 0; i < numberOfGroups! - groups.length; i++) {
                            newGroups.push({
                                numberOfGroup: groups.length + i + 1,
                                users: []
                            });
                        }
                        setGroups(x => [...x!, ...newGroups]);
                        setNumberConfirmed(true);
                    } else if (numberOfGroups! < groups.length) {
                        dispatch(setValuesAndOpenAlertModalReducer({
                            title: 'Confirmar',
                            message: `La cantidad de Grupos va a bajar de ${groups.length} a ${numberOfGroups} y se van a borrar los datos de los Grupos restantes`,
                            animation: 3,
                            mode: 'confirm',
                            execution: () => {
                                setGroups(x => x!.filter(g => g.numberOfGroup <= numberOfGroups!));
                                setNumberConfirmed(true);
                            }
                        }));
                    } else {
                        setNumberConfirmed(true);
                    }
                }}
                disabled={!numberOfGroups || numberConfirmed}
            >
                Aceptar número de Grupos para seguir
            </button>
        </div>
        <Hr classes={'mt-5'} />
        <Groups
            groups={groups}
            numberConfirmed={numberConfirmed}
            setGroups={setGroups}
            users={users}
        />
        <div className={'d-flex justify-content-center'}>
            <div>
                <button
                    className={'btn btn-general-blue w-100 mt-4'}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={saveHandler}
                    disabled={!isValid}
                >
                    ACEPTAR CAMBIOS
                </button>
                <button
                    className={`btn btn-general-red w-100 mt-3`}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={cancelHandler}
                >
                    CANCELAR
                </button>
            </div>
        </div>
        <div className={`${isDarkMode ? 'text-white' : ''} text-center mt-3`}>
            *Para guardar, todos los grupos deben tener al menos Superintendente y Auxiliar
        </div>
        </>
    );
}
